// assets/byte-preferred-source-button.js
//
// Loads Google's official Preferred Sources publisher script once per page
// (regardless of how many byte-preferred-source-button instances render),
// and forwards clicks to GTM dataLayer / gtag for tracking.
//
// Exception to the "no CDN scripts" rule: this is Google's required
// first-party widget script for the Preferred Sources feature — there is
// no Shopify-native or self-hosted equivalent, same category as loading
// GTM/GA4.

if (!customElements.get("byte-preferred-source-button")) {
  class BytePreferredSourceButton extends HTMLElement {
    static hasLoadedPublisherScript = false;

    constructor() {
      super();

      this.boundHandleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.#loadPublisherScript();
      this.#bindEvents();
    }

    disconnectedCallback() {
      this.#unbindEvents();
    }

    handleClick(event) {
      const trigger = event.target.closest("[google-add-preferred-source-btn]");
      if (!trigger) return;

      this.#trackButtonClick();
    }

    #loadPublisherScript() {
      if (BytePreferredSourceButton.hasLoadedPublisherScript) return;
      if (document.querySelector("script[data-preferred-source-publisher]")) {
        BytePreferredSourceButton.hasLoadedPublisherScript = true;
        return;
      }

      const publisherScript = document.createElement("script");
      publisherScript.src = "https://news.google.com/swg/js/v1/publisher.js";
      publisherScript.async = true;
      publisherScript.dataset.preferredSourcePublisher = "";
      document.head.appendChild(publisherScript);

      BytePreferredSourceButton.hasLoadedPublisherScript = true;
    }

    #trackButtonClick() {
      const hasGoogleTagManager = Boolean(
        window.google_tag_manager &&
        Object.keys(window.google_tag_manager).some(
          (key) => key.indexOf("GTM-") === 0,
        ),
      );

      if (hasGoogleTagManager && Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: "preferred_source_button_click" });
        return;
      }

      if (typeof window.gtag === "function") {
        window.gtag("event", "preferred_source_button_click");
      }
    }

    #bindEvents() {
      this.addEventListener("click", this.boundHandleClick);
    }

    #unbindEvents() {
      this.removeEventListener("click", this.boundHandleClick);
    }
  }

  customElements.define(
    "byte-preferred-source-button",
    BytePreferredSourceButton,
  );
}
